import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { AvatarModule } from '../avatar/avatar.module';
import { DropdownModule } from './../dropdown/dropdown.module';
import { HeadingModule } from './../heading/heading.module';
import { IconModule } from './../icon/icon.module';
import { TruncateModule } from './../truncate/truncate.module';
import { MailPickerComponent } from './mail-picker.component';

@NgModule({
  declarations: [MailPickerComponent],
  exports: [MailPickerComponent],
  imports: [
    DropdownModule,
    AvatarModule,
    HeadingModule,
    CommonModule,
    TruncateModule,
    IconModule,
    I18nModule,
  ],
})
export class MailPickerModule {}
export { MailPickerComponent } from './mail-picker.component';
